(function (angular) {
    'use strict';

    angular.module('dataPreferences')

        /**
         *
         */
        .factory('dataPreferencesService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {
                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        setDataRetention: setDataRetention,
                        getDataRetention: getDataRetention
                    };

                    return fac;

                    function setDataRetention(apiSpaceId, data) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/retention", data)
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }

                    function getDataRetention(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/retention")
                            .then(function (response) {
                                return response.data;
                            }).catch(function (error) {
                                console.error(JSON.stringify(error));
                                return $q.reject(error);
                            });
                    }
                }]);
})(window.angular);

